import createClient from '@economic/http-client';

export default createClient(
    process.env.ECONOMIC_REST_PATH,
    `${process.env.ECONOMIC_INTERNALAPI_PATH}/internal-api/application/token`,
    process.env.ECONOMIC_PATH
);
